
import '../styling/DownloadCvModel.css';

import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DownloadCvModel() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button className='open-btn'  onClick={handleClickOpen}>
       Download Cv
      </Button>
      <Dialog
  open={open}
  slots={{
    transition: Transition,
  }}
  keepMounted
  onClose={handleClose}
  aria-describedby="alert-dialog-slide-description"
>
  <DialogTitle>{"CV Preview"}</DialogTitle>
  <DialogContent>
    <DialogContentText style={{
      color:'#0a1a33'
    }} id="alert-dialog-slide-description">
      Click "Preview" to preview the CV.  
      Click "Download" to download it.
    </DialogContentText>
  </DialogContent>
  <DialogActions>
      <a 
  href="https://drive.google.com/file/d/1dEzPZO_QNP_vbqdaMGaVcG1A_VOSzNps/view?usp=sharing" 
  target="_blank" 
  rel="noopener noreferrer" 
  title="View CV in PDF format"
>
  <Button onClick={handleClose}>Preview</Button>
</a>
   

  <a 
  href="https://drive.usercontent.google.com/u/0/uc?id=1dEzPZO_QNP_vbqdaMGaVcG1A_VOSzNps&export=download" 
  target="_blank" 
  rel="noopener noreferrer" 
  title="Download CV in PDF format"
>
   <Button onClick={handleClose}>Download</Button>
</a>

  </DialogActions>
</Dialog>

    </React.Fragment>
  );
}
